var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconWarning = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4999 10.625C10.8451 10.625 11.1249 10.3452 11.1249 10V6.25C11.1249 5.90482 10.8451 5.625 10.4999 5.625C10.1547 5.625 9.87489 5.90482 9.87489 6.25V10C9.87489 10.3452 10.1547 10.625 10.4999 10.625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7499 13.125C11.7499 12.4346 11.1902 11.875 10.4999 11.875C9.80953 11.875 9.24989 12.4346 9.24989 13.125C9.24989 13.8154 9.80953 14.375 10.4999 14.375C11.1902 14.375 11.7499 13.8154 11.7499 13.125Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1124 4.375H4.88736C3.91879 4.375 3.31822 5.429 3.812 6.26225L9.42453 15.7334C9.90867 16.5504 11.0911 16.5504 11.5753 15.7334L17.1878 6.26225C17.6816 5.429 17.081 4.375 16.1124 4.375ZM4.88736 3.125H16.1124C18.0496 3.125 19.2507 5.233 18.2631 6.89951L12.6506 16.3706C11.6823 18.0046 9.31745 18.0046 8.34916 16.3706L2.73664 6.89951C1.74908 5.233 2.95022 3.125 4.88736 3.125Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconWarning);
export default ForwardRef;